import './DateRangeInputBeacon.scss';
import React, { useRef, useState } from 'react';
import { convertToMMDDYYYY } from 'services/Dates';
import { AAMBeaconButton, AAMBeaconError } from 'components/shared/Beacon';
import DateInputBeacon from "./DateInputBeacon";
import { handleDateFormSubmit } from './DateFormValidation';

const DateRangeInputBeacon = ({
  minDate,
  maxDate,
  toDate,
  fromDate,
  toggleFromDate,
  toggleToDate,
  toggleTimePeriod,
  timePeriodLabel,
  goCTAClickFunction,
  fromLabel = '',
  toLabel = '',
  hideLabels = false,
  customClasses,
  iosMobile = false,
}) => {
  const formRef = useRef(null);
  const [showInvalidDatemessage, setShowInvalidDateMessage] = useState(false);


  function dispatchOnClick(event) {
    event.preventDefault();
    if (formRef.current) {
      handleDateFormSubmit(formRef.current, (showInvalid) => {
        setShowInvalidDateMessage(showInvalid);
        if (!showInvalid && formRef.current.checkValidity()) {
          goCTAClickFunction(fromDate, toDate);
        }
      });
    }
  }

  return (
    <div >
      {toggleTimePeriod && (
        <div className="select-labels">
          <span>Custom Range</span>
          <a onClick={toggleTimePeriod}>{timePeriodLabel}</a>
        </div>
      )}
      <form onSubmit={dispatchOnClick} noValidate ref={formRef}>
        <div className="select-dates-beaconized">
          {iosMobile && <p className={"beacon-name-labels"}>{fromLabel}</p>}
          <DateInputBeacon
            id="from-date-beacon"
            minDate={minDate}
            label={fromLabel}
            maxDate={maxDate}
            onChange={toggleFromDate}
            defaultDate={fromDate}
            hideLabels={hideLabels}
            updateDateAlways
            customClasses={customClasses}
          />


          {iosMobile && <p className={"beacon-name-labels"}>{toLabel}</p>}
          <DateInputBeacon
            id="to-date-beacon"
            minDate={minDate}
            maxDate={maxDate}
            onChange={toggleToDate}
            defaultDate={toDate}
            label={toLabel}
            hideLabels={hideLabels}
            updateDateAlways
            customClasses={customClasses}
          />

          <AAMBeaconButton
            id={'go-cta-button'}
            type='submit'
            variant="primary"
            scale="normal"
          >
            Go
          </AAMBeaconButton>
        </div>
        {showInvalidDatemessage && (
            <AAMBeaconError id="date-beacon-error">
              {`Please select a date range between ${convertToMMDDYYYY(minDate)} and ${convertToMMDDYYYY(maxDate)}`}
            </AAMBeaconError>
        )}
      </form>
    </div>
  );
};

export default DateRangeInputBeacon;
